import type { HTMLAttributes, ReactNode } from 'react';
import { kaiFontFamily, styleguideColorsExtended as colors } from '../../../core/tokens';
import { resolveStyleOverride, type StyleOverride } from '../../styleOverrides';
import { kaiTypographyWeb } from '../../typography';

export interface GallerySelectionActionBarProps extends HTMLAttributes<HTMLDivElement> {
  selectedCount: number;
  open?: boolean;
  label?: string;
  actions: ReactNode;
  styleOverride?: StyleOverride;
}

export const GallerySelectionActionBar = ({
  selectedCount,
  open = selectedCount > 0,
  label,
  actions,
  styleOverride: barCss,
  style,
  ...props
}: GallerySelectionActionBarProps) => (
  <div
    role='toolbar'
    aria-label='Gallery selection actions'
    aria-hidden={!open}
    data-gallery-selection-action-bar='true'
    data-gallery-open={open ? 'true' : 'false'}
    style={{
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
      minHeight: 56,
      padding: '12px 20px',
      background: colors.ink,
      color: colors.white,
      boxShadow: '0 -6px 24px rgba(26,26,26,.18)',
      fontFamily: kaiFontFamily,
      opacity: open ? 1 : 0,
      pointerEvents: open ? 'auto' : 'none',
      transform: open ? 'translateY(0)' : 'translateY(110%)',
      transition: 'opacity 200ms ease, transform 200ms cubic-bezier(.4,0,.2,1)',
      visibility: open ? 'visible' : 'hidden',
      ...style,
      ...resolveStyleOverride(barCss),
    }}
    {...props}
  >
    <span style={{ ...kaiTypographyWeb.xSmallBold, letterSpacing: '0.05em' }}>
      {label ?? `${selectedCount} selected`}
    </span>
    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>{actions}</span>
  </div>
);
